import { TableTemplateV2 } from "../dashboard/TableTemplate-v2";
import { TableWidget } from "./TableWidget";
import { DefaultFetchService } from "app/services/fetchService";
import { AudienceInterestsAPIService } from "app/pages/website-analysis/audience-interests/single/AudienceInterests/AudienceInterestsAPIService";
import { fetchWithFullResponseInterceptorHandlers } from "app/components/widget/widget-fetchers/DefaultDataFetcher";
import { filterQueryParamBuilder } from "app/UtilitiesAndConstants/UtilityFunctions/LegacyTableFilters";
import { DefaultCellHeaderRightAlign } from "app/components/React/Table/headerCells";
import { ChangePercentage } from "app/components/React/Table/cells";
import { i18nFilter } from "app/filters/i18nFilter";

const i18n = i18nFilter();

export class AudienceInterestsTableWidget extends TableWidget {
    static getWidgetDashboardType() {
        return "Table";
    }

    static getWidgetMetadataType() {
        return "AudienceInterestsTable";
    }

    static getWidgetResourceType() {
        return "Table";
    }

    protected getMetricColumnsConfig() {
        const columns = [
            {
                name: "Domain",
                title: i18n("analysis.source.referrals.table.columns.domain.title"),
                type: "string",
                format: "None",
                sortable: "False",
                isSorted: "False",
                sortDirection: "desc",
                groupable: "True",
                cellTemp: "website-tooltip-top-cell",
                totalCount: "False",
                minWidth: 180,
            },
            {
                name: "Category",
                title: i18n("analysis.source.referrals.table.columns.category.title"),
                type: "string",
                format: "prettifyCategory",
                sortable: true,
                isSorted: false,
                sortDirection: "desc",
                groupable: false,
                cellTemp: "default-cell",
                totalCount: false,
                minWidth: 180,
            },
            {
                name: "Rank",
                title: i18n("analysis.source.referrals.table.columns.rank.title"),
                type: "long",
                format: "rank",
                sortable: "True",
                isSorted: "False",
                sortDirection: "asc",
                groupable: "False",
                cellTemp: "rank-cell",
                headerComponent: DefaultCellHeaderRightAlign,
                totalCount: "False",
                width: 110,
            },
            {
                name: "RelevancyScore",
                title: i18n("analysis.audience.interests.organic.table.columns.relevancyScore.title"),
                cellTemp: "score-bar-cell",
                sortable: true,
                minWidth: 135,
                ppt: {
                    overrideFormat: "abbrNumber",
                },
            },
            {
                name: "Overlap",
                title: i18n("analysis.audience.interests.organic.table.columns.score.title"),
                type: "double",
                format: "percentage",
                sortable: "True",
                isSorted: "False",
                sortDirection: "desc",
                groupable: "False",
                cellTemp: "percentage-cell",
                totalCount: "False",
                progressBarTooltip: "Visits",
                width: 110,
                ppt: {
                    overrideFormat: "smallNumbersPercentage:2",
                },
            },
            {
                name: "OverlapChange",
                title: i18n("audience.interests.table.columns.overlap.change"),
                sortable: true,
                groupable: false,
                cellComponent: ChangePercentage,
                headerComponent: DefaultCellHeaderRightAlign,
                width: 112,
                ppt: {
                    overrideFormat: "smallNumbersPercentage:2",
                },
            },
            {
                name: "HasAdsense",
                title: i18n("analysis.all.table.columns.googleAds.title"),
                type: "bool",
                format: "None",
                sortable: "True",
                isSorted: "False",
                sortDirection: "desc",
                groupable: "False",
                cellTemp: "adsense-cell",
                totalCount: "False",
                width: 80,
            },
        ];
        return columns;
    }

    private dataFetcherFactory = () => {
        return {
            create: (widget) => {
                return {
                    fetch: () => {
                        const fetchService = DefaultFetchService.getInstance();
                        const endpoint = AudienceInterestsAPIService.getApiEndpoint();
                        const apiParams = { ...widget.apiParams };
                        apiParams.key = apiParams.keys;
                        if (apiParams.search) {
                            apiParams.filter = filterQueryParamBuilder({
                                domain: apiParams.search,
                            });
                        }
                        delete apiParams.keys;
                        apiParams.withSharedCustomCategories = true; // The backend needs this flag to determine if it should allow shared custom categories when we are on the dashboard.
                        return fetchService
                            .get(endpoint, apiParams)
                            .then(...fetchWithFullResponseInterceptorHandlers)
                            .then((rawData) => ({
                                ...rawData,
                                Data: rawData.Records,
                            }));
                    },
                };
            },
        };
    };

    constructor() {
        super();
    }

    public getFetcherFactory() {
        return this.dataFetcherFactory();
    }

    get templateUrl() {
        return `/app/components/widget/widget-templates/table.html`;
    }

    get templateComponent() {
        return TableTemplateV2;
    }
    public getProUrl(rowParams) {
        if (rowParams) {
            return super.getProUrl(rowParams);
        }
        const queryParams = { ...this._params };
        const { category: audienceCategory, customCategory } = queryParams;
        const apiParams = Object.assign(this._getProUrlParams(), this._metricConfig.stateParams, rowParams);
        return this._swNavigator.href(this._metricConfig.state, {
            ...apiParams,
            audienceCategory,
            customCategory,
        });
    }
}
AudienceInterestsTableWidget.register();
